import { useState } from "react";
import { UserPlus, X } from "lucide-react";
import { useUserSearch } from "./useUserSearch";
import { UserSuggestions } from "./UserSuggestions";

// Chip-style picker for tagging people on a post. value: [{ username, display_name?, avatar_url? }]
export const PeoplePicker = ({ value, onChange, testid = "people-picker" }) => {
  const [q, setQ] = useState("");
  const [active, setActive] = useState(0);
  const found = useUserSearch(q.replace(/^@/, ""));
  const users = found.filter((u) => !value.some((v) => v.username === u.username));

  const add = (u) => { if (value.length < 20) onChange([...value, u]); setQ(""); setActive(0); };
  const remove = (username) => onChange(value.filter((v) => v.username !== username));

  const keyDown = (e) => {
    if (!users.length) {
      if (e.key === "Backspace" && !q && value.length) remove(value[value.length - 1].username);
      return;
    }
    if (e.key === "ArrowDown") { e.preventDefault(); setActive((a) => (a + 1) % users.length); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setActive((a) => (a - 1 + users.length) % users.length); }
    else if (e.key === "Enter") { e.preventDefault(); add(users[Math.min(active, users.length - 1)]); }
    else if (e.key === "Escape") setQ("");
  };

  return (
    <div data-testid={testid} className="relative">
      <div className="flex flex-wrap items-center gap-1.5 bg-[#141414] border border-[#1C1C1F] rounded-xl px-3 py-2 focus-within:border-[#0066FF] transition-colors">
        <UserPlus size={15} className="text-[#52525B] shrink-0" />
        {value.map((v) => (
          <span key={v.username} data-testid={`${testid}-chip-${v.username}`} className="inline-flex items-center gap-1 bg-[#0066FF]/15 text-[#7FB2FF] text-xs font-semibold rounded-full pl-2.5 pr-1 py-1">
            @{v.username}
            <button type="button" aria-label={`Remove ${v.username}`} data-testid={`${testid}-remove-${v.username}`} onClick={() => remove(v.username)} className="w-4 h-4 rounded-full hover:bg-white/10 flex items-center justify-center"><X size={11} /></button>
          </span>
        ))}
        <input
          data-testid={`${testid}-input`}
          value={q}
          onChange={(e) => { setQ(e.target.value); setActive(0); }}
          onKeyDown={keyDown}
          onBlur={() => setTimeout(() => setQ(""), 150)}
          placeholder={value.length ? "Tag more people…" : "Tag people (search by name)"}
          className="flex-1 min-w-[140px] bg-transparent text-sm text-white placeholder:text-[#52525B] focus:outline-none py-0.5"
        />
      </div>
      <UserSuggestions users={users} active={active} onPick={add} testid={`${testid}-suggestions`} />
    </div>
  );
};
